import React from 'react'
import { Routes, Route } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import Home from 'pages/Dashboard'
import ProductList from 'pages/Dashboard/ProductsList'
import ProductDetail from 'pages/Dashboard/ProductDetail'
import QuickOrder from 'pages/Dashboard/QuickOrder'
import Cart from 'pages/Dashboard/Cart'
import Checkout from 'pages/Dashboard/Checkout'
import Promotion from 'pages/Dashboard/Promotion'
import PromoCodes from 'pages/Dashboard/PromoCodes'
import WishlistPage from 'pages/Dashboard/User/WishlistPage'
import Productviewed from 'pages/Dashboard/User/Productviewed'
import HistoryPurchased from 'pages/Dashboard/User/HistoryPurchased'
import Import from 'pages/Dashboard/BulkOrder/Import'
import MyOrder from 'pages/Dashboard/User/MyOrder'
import MyOrderDetail from 'pages/Dashboard/User/MyOrderDetail'
import MyAccount from 'pages/Dashboard/User/MyAccount'
import LoyaltyPoints from 'pages/Dashboard/User/LoyaltyPoints'
import MyVoucher from 'pages/Dashboard/User/MyVoucher'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/products' element={<ProductList />} />
        <Route path='/products/:category_slug' element={<ProductList />} />
        <Route path='/products/lasted' element={<ProductList />} />
        <Route path='/product/:slug' element={<ProductDetail />} />
        <Route path='/quick-order' element={<QuickOrder />} />
        <Route path='/promotion' element={<Promotion />} />
        <Route path='/promo-codes' element={<PromoCodes />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/user/wishlist' element={<WishlistPage />} />
        <Route path='/productviewed' element={<Productviewed />} />
        <Route path='/history-purchased' element={<HistoryPurchased />} />
        <Route path='/bulk-order/import' element={<Import />} />
        <Route path='/my-order' element={<MyOrder />} />
        <Route path='/my-order/:slug' element={<MyOrderDetail />} />
        <Route path='/my-account' element={<MyAccount />} />
        <Route path='/users/loyalty_points' element={<LoyaltyPoints />} />
        <Route path='/users/my-voucher' element={<MyVoucher />} />
      </Routes >
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

export default App
